import React from 'react'
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { CdnInitFunction, snippet, startPrecheck, stopPrecheck, startSessions, stopSessions } from '../../constant';
import GetStartedShell, { CodeCard, CopyButton, getStartedSteps } from '../GetStartedShell';

const Content = () => {
	const { t } = useTranslation();

	const handleCopy = (url) => {
		navigator.clipboard.writeText(url);
	};

	return (
		<GetStartedShell
			title={t('how_mereos_library_works')}
			description={t('mereos_library_hero_desc')}
			steps={getStartedSteps(t)}
		>
			<div className="library-page__panel">
				<h2 className="library-page__panel-title">{t('overview')}</h2>
				<p className="library-page__panel-text">{t('mereos_is_a_javaScript_library')}</p>
				<p className="library-page__panel-text">{t('cdn_overview_extra')}</p>
			</div>

			<div className="library-page__panel">
				<h2 className="library-page__panel-title">{t('cdn_link')}</h2>
				<p className="library-page__panel-text">{t('as_reference')}</p>
				<CopyButton onCopy={() => handleCopy(snippet)} label={t('copy')} />
				<CodeCard>{snippet}</CodeCard>
			</div>

			<div className="library-page__panel">
				<h2 className="library-page__panel-title">{t('example_usage')}</h2>
				<p className="library-page__panel-text">{t('example_usage_intro')}</p>
			</div>

			<div className="library-page__panel" id="get-started-init">
				<h2 className="library-page__panel-title">{t('init_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_initiate')}</p>
				<CopyButton onCopy={() => handleCopy(CdnInitFunction)} label={t('copy')} />
				<CodeCard>{CdnInitFunction}</CodeCard>
				<p className="library-page__params-heading">{t('init_parameters_note')}</p>
				<ul className="library-page__param-list">
					<li className="library-page__param-item"><code className="library-page__inline-code">token</code>: <span dangerouslySetInnerHTML={{ __html: t('obtain_token_from_backend') }}></span></li>
					<li className="library-page__param-item"><code className="library-page__inline-code">candidate_object</code>: {t('candidate_object_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">external_id</code> {t('in_candidate_object_is_a_unique_id')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">profile_id</code>: {t('is_related_to_proctoring_profile')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">assessment_object</code>: {t('assessment_object_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">external_id</code> {t('in_assessment_object_is_the_id')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">theme_object</code>: {t('theme_object_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">callback</code>: {t('callback_init_note')}</li>
				</ul>
			</div>

			<div className="library-page__panel" id="get-started-prechecks">
				<h2 className="library-page__panel-title">{t('precheck_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_start_prechecks')}</p>
				<CopyButton onCopy={() => handleCopy(startPrecheck)} label={t('copy')} />
				<CodeCard>{startPrecheck}</CodeCard>
				<p className="library-page__params-heading">{t('precheck_parameters_note')}</p>
				<ul className="library-page__param-list">
					<li className="library-page__param-item"><code className="library-page__inline-code">callback</code>: {t('callback_precheck_note')}</li>
					<li className="library-page__param-item"><code className="library-page__inline-code">session_resume</code>: {t('session_resume_key_description')}</li>
				</ul>
			</div>

			<div className="library-page__note">
				<span className="library-page__note-badge">
					<Info className="library-page__note-badge-icon" aria-hidden="true" />
					{t('optional_note_badge')}
				</span>
				<h2 className="library-page__note-title">{t('stop_precheck_step_title')}</h2>
				<p className="library-page__note-text">{t('function_is_used_to_stop_prechecks')}</p>
				<CopyButton onCopy={() => handleCopy(stopPrecheck)} label={t('copy')} />
				<CodeCard>{stopPrecheck}</CodeCard>
				<p className="library-page__params-heading">{t('stop_precheck_parameters_note')}</p>
				<ul className="library-page__param-list">
					<li className="library-page__param-item"><code className="library-page__inline-code">callback</code>: {t('callback_stop_precheck_note')}</li>
				</ul>
			</div>

			<div className="library-page__panel" id="get-started-start-session">
				<h2 className="library-page__panel-title">{t('start_session_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_start_the_session')}</p>
				<CopyButton onCopy={() => handleCopy(startSessions)} label={t('copy')} />
				<CodeCard>{startSessions}</CodeCard>
			</div>

			<div className="library-page__panel" id="get-started-stop-session">
				<h2 className="library-page__panel-title">{t('stop_session_step_title')}</h2>
				<p className="library-page__panel-text">{t('function_is_used_to_finish_the_session')}</p>
				<CopyButton onCopy={() => handleCopy(stopSessions)} label={t('copy')} />
				<CodeCard>{stopSessions}</CodeCard>
			</div>
		</GetStartedShell>
	)
}

export default Content
